import vsComponent from './vsDivider'

export default Vue => {
  Vue.component(vsComponent.name, vsComponent)
}
